import React from 'react'
import {INavNotification} from '@api/user/account/notification/getNotification'
import {useTranslation} from '@lib/intl/useTranslations'
import useNavigation from '@hook/useNavigation'
import NotificationItemLayout from '@feature/account/components/notifications/NotificationListItem/layout/NotificationItemLayout'

interface INotificationItem extends INavNotification {}

const InvoiceIncomingNotificationItem = (props: INotificationItem) => {
    const t = useTranslation()
    const {goKeyDetail} = useNavigation()

    return (
        <NotificationItemLayout
            {...props}
            text={t('globalNotification.NotificationItem.invoice.expected.reminder', {count: props?.data?.days})}
            onClick={() => {
                goKeyDetail(props?.data?.key_id)
            }}
        />
    )
}

export default InvoiceIncomingNotificationItem
